import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import About from '@/components/About';
import Gallery from '@/components/Gallery';
import Features from '@/components/Features';
import Products from '@/components/Products';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import Disclaimer from '@/pages/Disclaimer';
import TermsAndConditions from '@/pages/TermsAndConditions';

const HomePage = () => {
    return (
        <>
            <Header />
            <main>
                <Hero />
                <About />
                <Gallery />
                <Features />
                <Products />
                <Contact />
            </main>
            <Footer />
            <WhatsAppButton />
        </>
    );
};

const PolicyLayout = ({ children }) => {
    return (
        <>
            <Header />
            {children}
            <Footer />
            <WhatsAppButton />
        </>
    );
};

function App() {
    return (
        <div className="min-h-screen bg-background">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/privacy-policy" element={
                        <PolicyLayout>
                            <PrivacyPolicy />
                        </PolicyLayout>
                    } />
                    <Route path="/disclaimer" element={
                        <PolicyLayout>
                            <Disclaimer />
                        </PolicyLayout>
                    } />
                    <Route path="/terms-and-conditions" element={
                        <PolicyLayout>
                            <TermsAndConditions />
                        </PolicyLayout>
                    } />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
